import { useQuery } from '@tanstack/react-query';
import algoliasearch from 'algoliasearch/lite';

import type { AlgoliaSearchResult } from '@/hooks/useAlgoliaSearch';

import {
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  PUBLIC_SWS_ENV,
} from '@/constants/env';

const algoliaAppId = ALGOLIA_APP_ID;
const algoliaApiKey = ALGOLIA_API_KEY;

const index =
  PUBLIC_SWS_ENV === 'dev' || PUBLIC_SWS_ENV === 'local'
    ? 'companies-dev'
    : 'companies';

const algoliaClient = algoliasearch(algoliaAppId, algoliaApiKey);

export const useCompanyBatchSearch = (validQueries: string[]) =>
  useQuery({
    queryKey: ['TRANSACTION_COMPANY_BATCH_SEARCH', validQueries],
    queryFn: async () => {
      const response = await algoliaClient.search<AlgoliaSearchResult>(
        validQueries.map((query) => ({
          indexName: index,
          query,
          params: {
            highlightPostTag: ' ',
            highlightPreTag: ' ',
            restrictHighlightAndSnippetArrays: true,
          },
        }))
      );
      return response.results;
    },
    enabled: validQueries.length > 0,
    staleTime: 3600000, // 1 hour
  });

export type AlgoliaBatchSearchResults = NonNullable<
  ReturnType<typeof useCompanyBatchSearch>['data']
>;

export type AlgoliaBatchSearchResult = AlgoliaBatchSearchResults[number];
